/**
 * آرتِ میز — همان فایل‌هایی که اپِ یونیتی نشان می‌دهد، ولی تنبل.
 *
 * ارزشِ نسخه‌ی وب «لینک را باز کن و بازی کن» است و آن ارزش به سبکیِ اولین
 * بارگذاری بند است. صورتِ ورق‌ها روی هم ۲۳۱ کیلوبایت‌اند — دو برابرِ کلِ بسته‌ی
 * بازی. پس میز بی‌درنگ با ورق‌های کشیده‌شده‌ی CSS باز می‌شود و این‌ها پشتِ سر
 * می‌آیند؛ رسیدنشان که تمام شد، کلاسِ `art` روی <html> می‌نشیند و CSS خودش
 * تصویرها را جای نقاشیِ خودش می‌گذارد.
 *
 * چیزی اگر نرسد (اینترنتِ قطع، بلاکِ تصویر) بازی همان ورق‌های CSS را نگه
 * می‌دارد و هیچ‌چیز نمی‌شکند.
 */
const FILES = ["/art/table/cards.webp", "/art/table/back.webp", "/art/table/carpet.webp"];

let started = false;

export function loadTableArt(): void {
  if (started) return;
  started = true;
  // فقط وقتی هر سه رسیدند سوییچ می‌کنیم: نصفه‌سوییچ یعنی ورقِ تصویری کنارِ
  // ورقِ CSS، که از هر دو حالت بدتر است.
  let left = FILES.length;
  for (const src of FILES) {
    const img = new Image();
    img.onload = () => { if (--left === 0) document.documentElement.classList.add("art"); };
    img.onerror = () => { /* بی‌آرت هم میز کار می‌کند */ };
    img.src = src;
  }
}
